import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/leaf-with-shadow.png'
import _imports_1 from '@/assets/logos/GoldieMay_wide.png'
import _imports_2 from '@/assets/logos/LisaLouiseCooke.jpg'
import _imports_3 from '@/assets/logos/DearMyrtle.png'
import _imports_4 from '@/assets/logos/RandySeaver.jpg'
import _imports_5 from '@/assets/TC_vid_2025_Dec_GenGems_demo.png'
import _imports_6 from '@/assets/TC_vid_2025_Dec_GenGems.png'
import _imports_7 from '@/assets/TC_vid_2025_Sep_Myrte.png'
import _imports_8 from '@/assets/TC_vid_2025_Sep_Myrte_WackyWed.png'
import _imports_9 from '@/assets/TC_vid_2026_Mar_GoldieMay.png'
import _imports_10 from '@/assets/TC_vid_2026_Sep_GetStarted.png'
import _imports_11 from '@/assets/logos/Facebook.png'
import _imports_12 from '@/assets/logos/X.png'


const _withScopeId = n => (_pushScopeId("data-v-67e7eb31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "top-section" }
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"row top-border\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31></div>", 1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6 hero-cta" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, " Make your family tree irresistible. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " It's easy to create a fun, endless learning experience your family will love. ", -1))
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = { class: "primary-actions" }
const _hoisted_11 = { class: "col-md-6 hero-image" }
const _hoisted_12 = { class: "video-crop" }
const _hoisted_13 = {
  autoplay: "",
  muted: "",
  loop: "",
  playsinline: "",
  preload: "auto"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "partners" }
const _hoisted_16 = { class: "goldie-may" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "quotes container-lg" }
const _hoisted_20 = { class: "list-unstyled" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("blockquote", null, " \"Tree Crossing highlights my family tree data in ways that are meaningful to family members — fun, simple factoids that bring all this to life for them.\" ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("blockquote", null, " \"This is awesome! I have grandchildren that are very curious about genealogy, and this is a way to share it in a fun format.\" ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("blockquote", null, " \"Photos and files were uploaded with my tree. That is the most enticing thing for family members — they love the photos and files.\" ", -1))
const _hoisted_27 = { class: "value-section" }
const _hoisted_28 = { class: "youtube-section" }
const _hoisted_29 = { class: "container-lg" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Learn more from YouTube creators", -1))
const _hoisted_31 = { class: "list-unstyled youtube-tiles" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "A tree your whole family will enjoy"
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Interview"),
  /*#__PURE__*/_createTextVNode(" with Tree Crossing founders on Genealogy Gems with Lisa Louise Cooke")
], -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "Why would I use Tree Crossing?"
}, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Demo"),
  /*#__PURE__*/_createTextVNode(" of the Tree Crossing sharing experience on Genealogy Gems")
], -1))
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "Mondays with Myrt reviews Tree Crossing"
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "DearMYRTLE and Randy Seaver take Tree Crossing for a spin on Mondays with Myrt", -1))
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "DearMYRTLE's Wacky Wednesday featuring Tree Crossing"
}, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("See the \""),
  /*#__PURE__*/_createElementVNode("strong", null, "crossing"),
  /*#__PURE__*/_createTextVNode("\" in Tree Crossing with DearMYRTLE's Wacky Wednesday episode")
], -1))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: "Goldie May Integrates with Tree Crossing"
}, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Add "),
  /*#__PURE__*/_createElementVNode("strong", null, "AI research"),
  /*#__PURE__*/_createTextVNode(" to your own tree with Goldie May + Tree Crossing")
], -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: "Getting Started with Tree Crossing"
}, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("How to "),
  /*#__PURE__*/_createElementVNode("strong", null, "Get Started"),
  /*#__PURE__*/_createTextVNode(" with Tree Crossing - Full Walk-through")
], -1))
const _hoisted_49 = [
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = { class: "action-section" }
const _hoisted_51 = { class: "container-lg" }
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"decor\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31><img src=\"" + _imports_0 + "\" data-v-67e7eb31></div><h1 data-v-67e7eb31>Share your tree today!</h1><ul class=\"list-unstyled action-details\" data-v-67e7eb31><li data-v-67e7eb31>Uploading your tree is easy, fast, and completely free</li><li data-v-67e7eb31>Delete it later if you change your mind</li><li data-v-67e7eb31>Share with up to 5 people today, or choose a &quot;practically free&quot; plan to share with more</li></ul>", 3)
const _hoisted_55 = { class: "actions" }
const _hoisted_56 = { class: "share-section" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Tell your friends!", -1))
const _hoisted_58 = { class: "share-bar" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_11 }, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_12 }, null, -1))
const _hoisted_62 = [
  _hoisted_61
]

import { Environment } from '@/util/Environment'
import { trackClick } from '@/util/Analytics'
import HomePageValue from '@/public/HomePageValue.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

function assetUrl(relativePath: string) {
  return `${Environment.get('ASSET_URL')}/${relativePath}`
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_router_link, {
                  class: "btn btn-primary",
                  to: "/signup",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(trackClick)('home_cta_hero_upload', { section: 'hero', id: 'cta_hero_upload', target: '/signup' })))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Upload my tree ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "btn btn-outline-primary",
                  to: "/plans",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(trackClick)('home_cta_hero_plans', { section: 'hero', id: 'cta_hero_plans', target: '/plans' })))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Choose a plan ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("video", _hoisted_13, [
                _createElementVNode("source", {
                  src: assetUrl('tc-demo-explore.final.mp4'),
                  type: "video/mp4"
                }, null, 8, _hoisted_14)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createTextVNode(" Works with "),
        _createElementVNode("a", {
          href: "https://www.goldiemay.com",
          target: "_blank",
          rel: "noopener",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(trackClick)('home_partner_goldie_may', { section: 'partners', id: 'partner_goldie_may', target: 'https://www.goldiemay.com' })))
        }, _hoisted_18)
      ])
    ]),
    _createElementVNode("section", _hoisted_19, [
      _createElementVNode("ul", _hoisted_20, [
        _createElementVNode("li", null, [
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("a", {
            href: "https://lisalouisecooke.com",
            target: "_blank",
            rel: "noopener",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(trackClick)('home_quote_lisa_louise_cooke', { section: 'quotes', id: 'quote_lisa_louise_cooke', target: 'https://lisalouisecooke.com' })))
          }, " Lisa Louise Cooke, host of the Genealogy Gems podcast since 2007 ")
        ]),
        _createElementVNode("li", null, [
          _hoisted_23,
          _hoisted_24,
          _createElementVNode("a", {
            href: "https://dearmyrtle.com",
            target: "_blank",
            rel: "noopener",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(trackClick)('home_quote_dearmyrtle', { section: 'quotes', id: 'quote_dearmyrtle', target: 'https://dearmyrtle.com' })))
          }, " DearMYRTLE, genealogy forum and webinar host since 1985 ")
        ]),
        _createElementVNode("li", null, [
          _hoisted_25,
          _hoisted_26,
          _createElementVNode("a", {
            href: "https://geneamusings.com",
            target: "_blank",
            rel: "noopener",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(trackClick)('home_quote_randy_seaver', { section: 'quotes', id: 'quote_randy_seaver', target: 'https://geneamusings.com' })))
          }, " Randy Seaver, prolific genealogy blogger since 1992 ")
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_27, [
      _createVNode(HomePageValue)
    ]),
    _createElementVNode("section", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("ul", _hoisted_31, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "https://www.youtube.com/watch?v=ryCC8osoxlo",
              target: "_blank",
              rel: "noopener",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(trackClick)('home_vid_GenGems_demo', { section: 'youtube', id: 'vid_GenGems_demo', target: 'youtube' })))
            }, _hoisted_34)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "https://www.youtube.com/watch?v=NpS7QxJlaGU",
              target: "_blank",
              rel: "noopener",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(trackClick)('home_vid_GenGems', { section: 'youtube', id: 'vid_GenGems', target: 'youtube' })))
            }, _hoisted_37)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "https://www.youtube.com/live/DYOEyqs-PIc?t=1947",
              target: "_blank",
              rel: "noopener",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(trackClick)('home_vid_Myrt', { section: 'youtube', id: 'vid_Myrt', target: 'youtube' })))
            }, _hoisted_40)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "https://www.youtube.com/watch?v=rJbQa-EVpUE",
              target: "_blank",
              rel: "noopener",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(trackClick)('home_vid_WackyWed', { section: 'youtube', id: 'vid_WackyWed', target: 'youtube' })))
            }, _hoisted_43)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "https://www.youtube.com/watch?v=YRtjvfe7zyo&t=177",
              target: "_blank",
              rel: "noopener",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(trackClick)('home_vid_GoldieMay', { section: 'youtube', id: 'vid_GoldieMay', target: 'youtube' })))
            }, _hoisted_46)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "https://www.youtube.com/watch?v=eFNnTUnXmp4",
              target: "_blank",
              rel: "noopener",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(trackClick)('home_vid_GetStarted', { section: 'youtube', id: 'vid_GetStarted', target: 'youtube' })))
            }, _hoisted_49)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_50, [
      _createElementVNode("div", _hoisted_51, [
        _hoisted_52,
        _createElementVNode("div", _hoisted_55, [
          _createVNode(_component_router_link, {
            class: "btn btn-primary",
            to: "/signup",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(trackClick)('home_cta_bottom_upload', { section: 'bottom-cta', id: 'cta_bottom_upload', target: '/signup' })))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Upload my tree ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "btn btn-outline-primary",
            to: "/plans",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(trackClick)('home_cta_bottom_plans', { section: 'bottom-cta', id: 'cta_bottom_plans', target: '/plans' })))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Choose a plan ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_56, [
      _hoisted_57,
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("a", {
          href: "https://www.facebook.com/sharer/sharer.php?u=https://www.treecrossing.com",
          target: "_blank",
          rel: "noopener",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(trackClick)('home_share_facebook', { section: 'share', id: 'share_facebook', target: 'facebook' })))
        }, _hoisted_60),
        _createElementVNode("a", {
          href: "https://twitter.com/intent/tweet?url=https://www.treecrossing.com&text=The%20best%20way%20to%20share%20your%20family%20trees.",
          target: "_blank",
          rel: "noopener",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(trackClick)('home_share_x', { section: 'share', id: 'share_x', target: 'x' })))
        }, _hoisted_62)
      ])
    ])
  ]))
}
}

})